"use client"

import { useState, useEffect, useCallback } from "react"

export function useMobile() {
  // Start with a consistent default state based on server-side check
  const [isMobile, setIsMobile] = useState(false)

  // Use useCallback to memoize the checkMobile function
  const checkMobile = useCallback(() => {
    // Check if window is defined (client-side)
    if (typeof window !== "undefined") {
      // Align with Tailwind 'md' breakpoint (>=768 is desktop layout for header)
      const isMobileDevice = window.innerWidth < 768
      setIsMobile(isMobileDevice)
    }
  }, [])

  // Effect for initial check and resize listener with debouncing
  useEffect(() => {
    // Check immediately
    checkMobile()

    // Add debounced resize listener to avoid performance issues
    let resizeTimer: NodeJS.Timeout
    const handleResize = () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(checkMobile, 100)
    }

    window.addEventListener("resize", handleResize)

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize)
      clearTimeout(resizeTimer)
    }
  }, [checkMobile]) // Include checkMobile in dependencies

  return isMobile
}
